import {StyleSheet, Text, View, Pressable, TextInput} from 'react-native';
import React, {useEffect, useState} from 'react';
import {useNavigation, useTheme} from '@react-navigation/native';
import Check from "./Check";
import {useDispatch, useSelector} from "react-redux";
import TransferTaskButton from "./TransferTaskButton";
import DeleteTaskButton from "./DeleteTaskButton";
import {changeText, checkTask} from "../function/functions";
import MatrixTaskButton from "./MatrixTaskButton";
import Moment from "moment";
import {useTranslation} from "react-i18next";
import Svg, {Path} from 'react-native-svg';

export const TaskItem = (props) => {
    const navigation = useNavigation();
    const currentTheme = useSelector(state => state.theme);
    const date = useSelector(state => state.date);
    const settings = useSelector(state => state.settings);
    const balances = useSelector(state => state.balance);
    const dispatch = useDispatch();
    const theme = useTheme();
    const {t, i18n} = useTranslation();

    const [height, setHeight] = useState(12);
    const [load, setLoad] = useState(false);
    const [edit, setEdit] = useState(false);
    const [layoutLoad, setLayoutLoad] = useState(false);
    const taskBalance = props.task.balance ? [...props.task.balance] : [];
    const [text, setText] = useState(props.task.text);
    useEffect(() => {
        setText(props.task.text);
    }, [props])
    useEffect(() => {
        if (load) {
            changeText(dispatch, props.task.id, text)
            setLoad(false)
        }
    }, [text])
    const styles = StyleSheet.create({
        none: {
            display:'none'
        },
        wrapper: {
            width:'100%',
            padding: 8
        },
        container: {
            width:'100%',
            display:'flex',
            flexDirection:'row',
            flexWrap: 'wrap',
            backgroundColor: theme.colors.scheme[4],
            borderRadius:22,
            padding: 8,
            position:'relative',
            borderWidth:2,
            borderColor:theme.colors.scheme[5]
        },
        taskWrapper: {
            width:'100%',
            display:'flex',
            flexDirection:'row',
            flexWrap:'nowrap',
            alignItems:'flex-start',
            fontFamily: 'Roboto-Regular'
        },
        textFront: {
            width:'100%',
            fontSize:16,
            fontFamily: 'Roboto-Regular',
            minHeight: 32,
            color: theme.colors.scheme[2],
            lineHeight: 20,
            paddingVertical: 0,
            paddingLeft:12,
            paddingRight:settings?.deletable && settings.deletable.enabled ? 60 : 24,
            textAlignVertical: 'top'
        },
        textFrontWrapper: {
            width:'100%'
        },
        text: {
            width:'100%',
            fontSize:16,
            fontFamily: 'Roboto-Regular',
            height: height,
            minHeight: 32,
            color: theme.colors.scheme[2],
            lineHeight: 20,
            paddingVertical: 0,
            paddingLeft:12,
            paddingRight:settings?.deletable && settings.deletable.enabled ? 52 : 24,
            textAlignVertical: 'top'
        },
        completed: {
            color: theme.colors.scheme[2],
            textDecorationLine:'line-through'
        },
        matrixBtnWrapper: {
            marginTop:2
        },
        balanceBtnWrapper: {
            marginTop:2
        },
        editBtnWrapper: {
            marginTop:2
        },
        deleteBtnWrapper: {
            width:32,
            height:32,
            borderWidth:1
        },
        transferLabel: {
            position:'absolute',
            top:-12,
            left:16,
            fontSize:12,
            display:(props.task?.transfer && props.task.transfer > 0 ? 'flex': 'none'),
            backgroundColor:theme.colors.scheme[1],
            fontFamily: 'Roboto-Regular',
            borderRadius:16,
            paddingHorizontal:6,
            paddingVertical:2,
            color:theme.colors.scheme[4],
            alignItems:'center',
            justifyContent:'center'
        },
        balanceCircleLabel: {
            width:16,
            height:16,
            borderRadius:16,
            marginRight:4
        },
        balanceTaskButton: {
            display: 'flex',
            height: 32,
            width:32,
            backgroundColor: currentTheme === 'contrast-light' ? theme.colors.scheme[5] : theme.colors.scheme[3],
            fontFamily: 'Roboto-Regular',
            fontSize: 16,
            marginHorizontal:2,
            borderWidth: (settings?.balance && settings.balance.enabled) ? 2 : 0,
            borderColor: theme.colors.scheme[6],
            borderRadius: 100,
            justifyContent:'center',
            alignItems:'center'
        },
        balanceButtonLabel: {
            display: 'flex',
            height: 32,
            backgroundColor: theme.colors.scheme[4],
            fontFamily: 'Roboto-Regular',
            fontSize: 16,
            marginHorizontal:0,
            marginTop:2,
            borderRadius: 100,
            justifyContent:'center',
            alignItems:'center'
        },
        transferButtonWrapper: {
        }
    });
    const layoutChange = (e) => {
        if (e.nativeEvent.layout.height >= 32 && !layoutLoad) {
            setHeight(e.nativeEvent.layout.height);
            setLayoutLoad(true);
        }
    }
    const onChange = (e) => {
        if (e.nativeEvent.target.scrollHeight >= 32)
            setHeight(e.nativeEvent.target.scrollHeight);
    }
    const onContentSizeChange = (e) => {
        if (e.nativeEvent.contentSize.height >= 32)
            setHeight(e.nativeEvent.contentSize.height)
    }
    const checkPress = (e) => {
        checkTask(dispatch, props.task.id, props.task.complete);
    }
    return(
        <View style={styles.wrapper}>
        <View style={styles.container}>
            {settings?.transfer ? <Text style={settings.transfer.enabled ? styles.transferLabel : {display:'none'}}>{t('task.transfered')} <Text style={{fontWeight:900}}>{props.task.transfer} </Text> {t('task.transferedpiece')}</Text> : null}
            <View style={styles.taskWrapper}>
                <Check title="Check" id={props.task.id} check={props.task.complete} onPress={checkPress} />
                {!edit ?
                    <Pressable style={styles.textFrontWrapper} onPress={() => {setEdit(true)}}><Text
                        style={[styles.textFront, props.task.complete ? styles.completed : null]}>{text === '' ? t('task.new') : text}</Text></Pressable>
                :
                    <TextInput
                        name={'task'+props.task.id}
                        id={'task'+props.task.id}
                        multiline={true}
                        style={[styles.text, props.task.complete ? styles.completed : null]}
                        onChangeText={(text) => {
                            setLoad(true)
                            setText(text)
                        }}
                        autoFocus = {true}
                        onLayout={layoutChange}
                        onContentSizeChange={onContentSizeChange}
                        onChange={onChange}
                        returnKeyType="done"
                        placeholder={t('task.new')}
                        onEndEditing={(e) =>
                        {
                            setEdit(false);
                        }}
                        blurOnSubmit={true}
                        maxLength={100}
                        value={text}
                    />
                }

                {settings?.deletable && settings.deletable.enabled ? <DeleteTaskButton title="Delete" navigation={navigation} id={props.task.id} completed={props.task.complete} /> : null}
            </View>
            <View style={{display:'flex', flexDirection:'row', flexWrap:'nowrap', width:'100%', alignItems:'flex-start', justifyContent:'flex-start', paddingBottom: (settings?.matrix && !settings.matrix.enabled && settings?.balance && !settings.balance.enabled && settings?.transfer && settings.transfer.enabled && !props.task.complete) ? 32 : 0}}>
                <View style={{display:'flex', flexDirection:'row', flexWrap:'wrap', width:'100%', paddingHorizontal:32, alignItems:'flex-start', justifyContent:'flex-start'}}>
                    <View style={(!settings.matrix.enabled ? styles.none : styles.matrixBtnWrapper)}>
                        <MatrixTaskButton title="Matrix" id={props.task.id} matrix={props.task.matrix ?? 0} />
                    </View>
                    {settings?.balance ? <View style={((!settings.balance.enabled || taskBalance.length > 0) ? styles.none : styles.balanceBtnWrapper)}>
                        <Pressable style={styles.balanceTaskButton} onPress={() => navigation.navigate('Balance', {task:{id:props.task.id, balance:taskBalance}})}>
                            <Svg style={{width:20, height:20, opacity:0.75}} viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg">
                                <Path d="M0 7.49996C0 3.52583 3.09098 0.27365 7 0.0163574V4.0354C5.30385 4.27801 4 5.73672 4 7.49996C4 9.43295 5.567 11 7.5 11C8.28618 11 9.01181 10.7407 9.5961 10.3031L12.438 13.1451C11.1188 14.3 9.39113 15 7.5 15C3.35786 15 0 11.6421 0 7.49996Z" fill={theme.colors.scheme[4]}/>
                                <Path d="M13.1451 12.438C14.3001 11.1187 15 9.39107 15 7.49996C15 6.46644 14.7909 5.48175 14.4128 4.58586L10.7552 6.21147C10.9132 6.61024 11 7.04496 11 7.49996C11 8.28611 10.7408 9.01174 10.3032 9.59602L13.1451 12.438Z" fill={theme.colors.scheme[4]}/>
                                <Path d="M8 4.0354V0.0163574C10.5416 0.183645 12.7373 1.61699 13.9626 3.69166L10.2541 5.33986C9.71063 4.64791 8.91203 4.16585 8 4.0354Z" fill={theme.colors.scheme[4]}/>
                            </Svg>
                        </Pressable></View> : null}
                    {settings?.balance && settings.balance.enabled ? taskBalance.map((prop, key) => {
                        return(<Pressable key={key} style={styles.balanceButtonLabel} onPress={() => navigation.navigate('Balance', {task:{id:props.task.id, balance:taskBalance}})}><View style={{display:'flex', flexDirection:'row', height:32, borderRadius:16,alignItems:'center', marginHorizontal:1, paddingHorizontal:8, borderWidth:2, borderColor:theme.colors.scheme[5], backgroundColor:theme.colors.scheme[3]}}><View style={[styles.balanceCircleLabel, {backgroundColor: balances[prop].color}]}></View><Text style={{lineHeight:16, marginTop:0, fontFamily:'Roboto-Regular', fontSize:12, color:theme.colors.scheme[2]}}>{t('balance.option.'+balances[prop].title)}</Text></View></Pressable>)
                    }) : null}
                </View>
                {settings?.transfer && settings.transfer.enabled && !props.task.complete ? <View style={{width:32, height:32, position:'absolute', right:0, top:2}}>
                    <TransferTaskButton title="Transfer" navigation={navigation} id={props.task.id} from={date} to={Moment(date, 'DD.MM.YYYY').add(1, 'days').format('DD.MM.YYYY')} />
                </View> : null}
            </View>
        </View>
        </View>
    )
}